export const API_ENDPOINTS = {
  AUTH: {
    SIGN_UP: "/users/sign-up",
    SIGN_IN: "/users/sign-in",
    VERIFY_USER: "/users/verify-user",
  },
  PRIVACY_POLICY: "/privacy-policy",
  USER: { UPDATE_USER: "/users/update-user-profile",GET_ALL:"/users/all" },
  CATEGORY: {
    GET_ALL: "/category/all",
    CREATE_CATEGORY: "/category/create",
    PRODUCTS_BY_NAME: "/products/search?search=",
    DELETE_CATEGORY: "/category/",
  },
  PRODUCTS: {
    GET_ALL: "/products/all",
    CREATE_PRODUCT: "/products/create",
    DELETE_PRODUCT: "/products/",
  },
  ORDERS: {
    CREATE_USER_ORDER: "/orders/create",
    GET_USER_ORDERS: "/orders/getMyOrders",
    GET_ALL_ORDERS: "/orders/all",
  },
  ADDRESS: {
    USER_ADDRESSES: "/address",
    ADD_NEW_ADDRESS: "/address",
    UPDATE_ADDRESS: "/address",
    DELETE_ADDRESS: "/address",
  },
  PAYMENT: {
    CREATE_PAYMENT_INTENT: "/payment-gate/create-stripe-customer",
    GET_SETUP_INTENT: "/payment-gate/get-setup-intent",
    GET_ALL_CARDS: "/payment-gate",
  },
};
